import React from 'react';
import {useParams} from 'react-router';

import {skipToken} from '@reduxjs/toolkit/query';

import {useGetSupportClientQuery} from 'src/containers/SupportClients/api';
import {useGetTenantDataQuery} from 'src/containers/User';

import {getClientStatus} from './utils';

export const useClientStatus = () => {
  const {id: supportTenantId} = useParams<'id'>();

  const {data: supportClient} = useGetSupportClientQuery(supportTenantId ?? skipToken);
  const {data: tenantData} = useGetTenantDataQuery(undefined, {skip: !!supportTenantId});

  const status = React.useMemo(() => {
    const client = supportClient ?? tenantData;

    return getClientStatus(client?.temporaryBlocked, client?.locked);
  }, [supportClient, tenantData]);

  return status;
};
